import { read } from "./read"

export const userProfileSearch = {
  read,
}
